import React from "react";
import SelectPopper from "./SelectPopper";
import { fieldToSelect } from "formik-material-ui";

const FormikSelectPopper = (props) => {
	return <SelectPopper {...fieldToSelect(props)} />;
};

export default FormikSelectPopper;
